import { createPortal } from 'react-dom'

const AcceptableUseModal = ({ onClose }: { onClose?: () => void }) => {
  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <button onClick={onClose} className="pf-modal__close" aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M8.28261 7.0001L13.7339 1.54851C14.0887 1.1939 14.0887 0.620557 13.7339 0.265953C13.3793 -0.088651 12.806 -0.088651 12.4514 0.265953L6.99992 5.71755L1.5486 0.265953C1.19384 -0.088651 0.620668 -0.088651 0.266072 0.265953C-0.0886906 0.620557 -0.0886906 1.1939 0.266072 1.54851L5.71739 7.0001L0.266072 12.4517C-0.0886906 12.8063 -0.0886906 13.3797 0.266072 13.7343C0.442789 13.9111 0.675145 14 0.907335 14C1.13953 14 1.37172 13.9111 1.5486 13.7343L6.99992 8.28266L12.4514 13.7343C12.6283 13.9111 12.8605 14 13.0927 14C13.3249 14 13.557 13.9111 13.7339 13.7343C14.0887 13.3797 14.0887 12.8063 13.7339 12.4517L8.28261 7.0001Z"
              fill="#A3A3A3"
            />
          </svg>
        </button>
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              All<span>Fans</span>
            </h2>
            <div className="pf-page__descr">Acceptable Use Policy</div>
          <div className="pf-content__description">
            <p>
            This acceptable use policy applies to your use of <strong>AllFans</strong> and forms part of your agreement 
            with us. This policy sets out the content standards that apply when you upload Content to <strong>AllFans</strong>, 
            contact other Users of <strong>AllFans</strong>, link to <strong>AllFans</strong>, or interact 
            with <strong>AllFans</strong> in any other way. In this policy, defined terms have the same meanings as in our <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
            </p>
          </div>
          <ol className="pf-main-list">
            <li>
              <p>You must not use AllFans except for your own personal use and must not sell, rent, transfer, 
                or share your account or any Content obtained from your use of AllFans to or with anyone else.</p>
            </li>
            <li>
                <p>You must only use AllFans in a way and for a purpose that is lawful.</p>
            </li>
            <li>
                <p>You must not upload, post, display, or publish Content on AllFans that is illegal, fraudulent, 
                    defamatory, hateful, discriminatory, threatening, or harassing or that encourages or promotes violence 
                    or any illegal activity.</p>
            </li>
            <li>
                <p>You must not use AllFans in any way that might exploit, harm, or try to exploit or harm any
                     individual under 18, for example, by exposing them to inappropriate Content.</p>
            </li>
            <li>
                <p>You must not upload, post, display, or publish Content on AllFans that:</p>
              <ol>
                <li>shows, includes, or refers to:
                    <ol className="ol-decimal">
                    <li>any individual under 18 (or that refers to individuals under 18 generally); or</li>
                    <li>any other individual unless you have written documentation that confirms that all individuals 
                        shown or included or referred to in your Content are at least 18, and you have written consent from 
                        each individual to use their name or images (or both) in the Content;</li>
                    </ol>
                </li>
                <li>
                  <p>shows, promotes, advertises, or refers to:</p>
                    <ol className="ol-decimal">
                    <li>firearms, weapons, or any goods whose sale, possession, or use is subject to prohibitions or restrictions;</li>
                    <li>drugs or drug paraphernalia;</li>
                    <li>self-harm or suicide;</li>
                    <li>incest;</li>
                    <li>bestiality;</li>
                    <li>violence, rape, lack of consent, hypnosis, intoxication, sexual assault, torture, sadomasochistic abuse 
                        or hardcore bondage, extreme fisting, or genital mutilation;</li>
                    <li>necrophilia;</li>
                    <li>urine, scatological, or excrement-related material;</li>
                    <li>“revenge porn” (being any sexually explicit material featuring any individual who has not given prior, 
                        express, and informed consent to that material (i) being taken, captured, or otherwise memorialized; or (ii) 
                        being posted and shared on AllFans);</li>
                    <li>escort services, sex trafficking, or prostitution;</li>
                    </ol>
                </li>
                <li>
                  <p>
                    contains unsolicited sexual Content or unsolicited language that sexually objectifies another User or anyone 
                    else in a nonconsensual way or contains fake or manipulated sexual Content regarding another User or anyone 
                    else (including “deepfakes”);
                  </p>
                </li>
                <li>
                    <p>
                     contains, promotes, advertises, or refers to hate speech (being Content intended to vilify, humiliate, 
                     dehumanize, exclude, attack, threaten, or incite hatred, fear of, or violence against a group or individual
                      based on race, ethnicity, national origin, immigration status, caste, religion, sex, gender identity or 
                      expression, sexual orientation, age, disability, disease, veteran status, or any other protected characteristic);   
                    </p>
                </li>
                <li>
                    <p>
                     contains or refers to anyone else’s personal information or private or confidential information (for example, 
                     telephone numbers, location information (including street addresses, and GPS coordinates), names, identity 
                     documents, email addresses, login credentials for AllFans including passwords and security questions, 
                     financial information including bank account and credit card details, biometric data, and medical records) 
                     without that person’s express written consent;  
                    </p>
                </li>
                <li>
                    <p>either:</p>
                    <ol className="ol-decimal">
                        <li>
                            <p>for Content featuring public nudity, was recorded in or is being broadcast from a jurisdiction where public 
                                nudity is illegal; or</p>
                        </li>
                        <li>
                            <p>for Content featuring sexual activities, was recorded in or is being broadcast from a public place where
                                 members of the public are reasonably likely to see the activities being performed (this does not include 
                                 outdoor places where members of the public are not present, for example, private property including a private 
                                 backyard, or secluded areas in nature where members of the public are not present);</p>
                        </li>
                    </ol>
                </li>
                <li>
                    <p>
                        gives the impression that it comes from or is approved, licensed, or endorsed by us or any other person or company;
                    </p>
                </li>
                <li>
                    <p>
                        causes or is calculated to cause inconvenience or anxiety to anyone else or that is likely to upset, embarrass, 
                        or cause serious offense to anyone else;
                    </p>
                </li>
                <li>
                    <p>
                        is used or is intended to be used to extract money or another benefit from anyone else in exchange for the removal of the Content; or
                    </p>
                </li>
                <li>
                    <p>
                        involves or promotes nonparty commercial activities or sales, including contests, sweepstakes, and 
                        other sales promotions, product placements, advertising, or job posting or employment ads without our 
                        prior express consent.
                    </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                You must not use AllFans to stalk, bully, abuse, harass, threaten, or intimidate anyone else.
              </p>
            </li>
            <li>
              <p>
                You must not use AllFans to engage in misleading or deceptive conduct or conduct likely to 
                mislead or deceive any other User.
              </p>
            </li>
            <li>
              <p>
                You must respect the intellectual property rights of Creators, including by not recording, reproducing, 
                sharing, communicating to the public, or otherwise distributing their Content without permission.
              </p>
            </li>
            <li>
              <p>
                You must do nothing that violates our or someone else’s rights, including intellectual property 
                rights (examples of which are copyright, trademarks, confidential information, and goodwill), personality 
                rights, unfair competition, privacy, and data protection rights.
              </p>
            </li>
            <li>
              <p>
                You must not impersonate us, one of our employees, another User, or any other person or company 
                or falsely state or suggest any affiliation, endorsement, or sponsorship between you and us or any 
                other person or company.
              </p>
            </li>
            <li>
              <p>
                You must not provide false account registration information or make unauthorized use of anyone 
                else’s information or Content.
              </p>
            </li>
            <li>
              <p>
                You must not post or cause to be posted any Content that is spam, has the intention or effect 
                of artificially increasing any Creator’s views or interactions, or is otherwise inauthentic, 
                repetitive, misleading, or low quality.
              </p>
            </li>
            <li>
              <p>
                You must not transmit, stream, or otherwise send any prerecorded audio or video material 
                during a live stream or otherwise try to pass off recorded material as a live stream.
              </p>
            </li>
            <li>
              <p>
                You must not use other media or methods (for example, using codewords or signals) 
                to communicate anything that violates this policy.
              </p>
            </li>
            <li>
              <p>
                You must not reproduce, print, distribute, try to download, modify, create 
                derivative works of, publicly display, publicly perform, republish, download, store, 
                or transmit any Content, except as permitted under the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
              </p>
            </li>
            <li>
              <p>
                You must not knowingly introduce any viruses, trojans, worms, logic bombs, or other 
                material into Content that is or might be malicious or technologically harmful.
              </p>
            </li>
            <li>
              <p>
                You must not decompile, disassemble, reverse engineer, or otherwise try to 
                discover or derive the source code of AllFans.
              </p>
            </li>
            <li>
              <p>
                You must not use AllFans in a way that could adversely affect our systems 
                or security or interfere with any other User’s use of AllFans, including their 
                ability to engage in real-time activities through AllFans.
              </p>
            </li>
            <li>
              <p>
                You must not use any automated program, tool, or process (including web crawlers, 
                robots, bots, spiders, and automated scripts) to access AllFans or any server, 
                network, or system associated with AllFans, or to extract, scrape, collect, 
                harvest, or gather Content or information from AllFans.
              </p>
            </li>
            <li>
              <p>
                You must not use AllFans’s name, logo, or any related or similar names, 
                logos, product and service names, designs, or slogans other than in the limited ways expressly 
                permitted in the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> or with our prior written agreement.
              </p>
            </li>
          </ol>
          <p className='note'>Breaches of this policy may lead to your account being suspended or terminated and access 
            to your earnings being revoked, as set out in the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> and <a href='/creatorterms' className='terms-link'>Creator Terms</a>.</p>
          </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <a href="#">
                <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.5001 0C8.55877 0 0.500244 8.05852 0.500244 17.9998C0.500244 27.9411 8.55877 35.9997 18.5001 35.9997C28.4414 35.9997 36.4999 27.9411 36.4999 17.9998C36.4999 8.05852 28.4414 0 18.5001 0Z"
                    fill="url(#paint0_linear_16531_7073)"
                  />
                  <path
                    d="M20.9352 22.7716H25.5936L26.3253 18.0394H20.9352V15.4528C20.9352 13.4872 21.5778 11.744 23.4165 11.744H26.3712V7.6148C25.8519 7.5446 24.7539 7.3916 22.6794 7.3916C18.3469 7.3916 15.8071 9.67938 15.8071 14.8921V18.0403H11.353V22.7725H15.8062V35.7791C16.6882 35.9105 17.5819 36.0005 18.499 36.0005C19.3279 36.0005 20.1369 35.9249 20.9352 35.8169V22.7716Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient id="paint0_linear_16531_7073" x1="5.89389" y1="5.39365" x2="33.4534" y2="32.9532" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#2AA4F4" />
                      <stop offset="1" stopColor="#007AD9" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a href="#">
                <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.499756" width="36" height="36" rx="18" fill="#5B5F69" />
                  <rect x="0.499756" width="36" height="36" rx="18" fill="#F7F7F7" />
                  <rect x="0.499756" width="36" height="36" rx="18" fill="#179AFF" />
                  <path
                    d="M24.7437 8.25H28.0517L20.8247 16.51L29.3267 27.75H22.6697L17.4557 20.933L11.4897 27.75H8.17966L15.9097 18.915L7.75366 8.25H14.5797L19.2927 14.481L24.7437 8.25ZM23.5827 25.77H25.4157L13.5837 10.126H11.6167L23.5827 25.77Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="#">
                <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.499756" width="36" height="36" rx="18" fill="white" />
                  <g clipPath="url(#clip0)">
                    <path
                      d="M25.4146 18.1661C25.4146 17.6767 25.3749 17.1846 25.2903 16.7031H18.499V19.4757H22.3881C22.2267 20.3699 21.7081 21.161 20.9488 21.6636V23.4626H23.269C24.6315 22.2086 25.4146 20.3567 25.4146 18.1661Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M18.499 25.2012C20.4409 25.2012 22.0785 24.5636 23.2717 23.463L20.9515 21.664C20.306 22.1032 19.4726 22.3519 18.5017 22.3519C16.6233 22.3519 15.0307 21.0846 14.4592 19.3809H12.0649V21.2354C13.2872 23.6667 15.7767 25.2012 18.499 25.2012Z"
                      fill="#34A853"
                    />
                    <path
                      d="M14.4568 19.3808C14.1552 18.4866 14.1552 17.5183 14.4568 16.6241V14.7695H12.0652C11.044 16.804 11.044 19.2009 12.0652 21.2354L14.4568 19.3808Z"
                      fill="#FBBC04"
                    />
                    <path
                      d="M18.499 13.6496C19.5255 13.6337 20.5176 14.02 21.261 14.729L23.3167 12.6734C22.015 11.4511 20.2875 10.7791 18.499 10.8003C15.7767 10.8003 13.2872 12.3347 12.0649 14.7687L14.4566 16.6233C15.0254 14.9168 16.6207 13.6496 18.499 13.6496Z"
                      fill="#EA4335"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="14.1143" height="14.4" fill="white" transform="translate(11.3 10.8008)" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div className="pf-footerMobile__actions">
              <p className="pf-footerMobile__copyright">&copy; 2026 AllFans.</p>
            </div>
          </div>
        </div>
      </div>
    </div>, document.body
  )
}

export default AcceptableUseModal
